import { render, staticRenderFns } from "./GBrandOrderForm.vue?vue&type=template&id=81f22234&scoped=true&"
import script from "./GBrandOrderForm.vue?vue&type=script&lang=ts&"
export * from "./GBrandOrderForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBrandOrderForm.vue?vue&type=style&index=0&id=81f22234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f22234",
  null
  
)

export default component.exports